module.exports = __webpack_public_path__ + "media/stylesheets/images/trash_@2X-c240a57a7f857e54ed72075920941dbf.png";